import React from 'react';
import { FormControl, Box, Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormState } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Arrival/AgentArrivalHypothesisModal/AgentArrivalForm';

type Props = {
    selectedGradeSelector: string;
    gradeList: string[];
    disabled?: boolean;
    formState: FormState;
    setFormState: React.Dispatch<React.SetStateAction<FormState>>;
};

export default function GradeSelector({
    selectedGradeSelector,
    formState,
    setFormState,
    gradeList,
    disabled = false,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl required fullWidth>
                <Autocomplete
                    options={gradeList.filter(
                        (v, index, self) => self.indexOf(v) === index,
                    )}
                    disabled={disabled}
                    noOptionsText={t('humanResources.simulation.noOptions')}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t(
                                'humanResources.simulation.addAgent.referentialGrade',
                            )}
                            required
                        />
                    )}
                    value={selectedGradeSelector}
                    onChange={(_, newValue) => {
                        setFormState({
                            ...formState,
                            officialGrade: newValue ?? '',
                        });
                    }}
                    isOptionEqualToValue={(option, value) => option === value}
                />
            </FormControl>
        </Box>
    );
}
